/**
 * @file index.ts
 * @description Индексный файл объектов системы управления задачами.
 * Экспортирует конфигурации для работы с объектами, включая версии тест-кейсов.
 * Централизованный реестр всех типов объектов, доступных в системе.
 * Обеспечивает единообразный доступ к различным сущностям через API.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies []
 * @related-files [./test-case-version.ts]
 */

import { IBasePage } from '@src/types/page';
import * as testCaseVersion from './test-case-version';

const items: IBasePage[] = [testCaseVersion];

export default items;
